module.exports = __webpack_public_path__ + "static/media/13.02c54a99.jpg";